import type React from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';

import { ScErrorBlock } from './styled';

interface ErrorBlockProps {
  logo: boolean;
  image?: string;
  text?: React.ReactNode;
  richText?: React.ReactNode;
  contactUsText?: string;
  buttonText?: string;
  showUrl?: boolean;
  handleOpenSupport?: () => void;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({
  logo,
  text,
  richText,
  buttonText,
  contactUsText,
  image,
  showUrl,
  handleOpenSupport,
}) => {
  const { t } = useTranslation('common');

  return (
    <ScErrorBlock>
      {logo && <div className="logo" />}
      {image && (
        <ImageComponent
          alt="error"
          className="image"
          height={300}
          src={image}
          width={400}
        />
      )}
      {text && <p>{text}</p>}
      {showUrl && (
        <span className="url">{`${typeof window !== 'undefined' && window?.location?.href}`}</span>
      )}
      {richText && <div className="rich-text">{richText}</div>}
      <div className="buttonWrap">
        {handleOpenSupport && (
          <Button onClick={handleOpenSupport} small whiteTransparent>
            {contactUsText ?? t('button.contactUs')}
          </Button>
        )}
        {buttonText && (
          <Button
            onClick={() =>
              typeof window !== 'undefined'
                ? (window.location.href = '/')
                : null
            }
            primary
            small
          >
            {buttonText}
          </Button>
        )}
      </div>
    </ScErrorBlock>
  );
};
